import React, { useState } from "react";
import styled from "styled-components";
import { createUserApi } from "../api";
import { Loader, PageHero } from "../components";
import { Link } from "react-router-dom";

const SignUp = () => {
  const [signUpData, setSignUpData] = useState({ userName: "", password: "" });
  const [logging, setLogging] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLogging(true);
    if (signUpData.userName === "" || signUpData.password === "") {
      alert("username or password cannot be empty");
    } else {
      await createUserApi(signUpData);
      setSignUpData({ userName: "", password: "" });
    }
    setLogging(false);
  };

  return (
    <>
      <PageHero title="signup"></PageHero>
      <Wrapper>
        {logging ? (
          <>
            <h1>Signing up...</h1>
            <Loader color="#fff"></Loader>
          </>
        ) : (
          <>
            <h1>Sign up</h1>
            <p>
              Welcome to the store, please enter your sign up credentials to
              create a new account.
            </p>
            <form onSubmit={(e) => handleLogin(e)}>
              <div>
                <i className="fa-solid fa-user"></i>
                <input
                  type="text"
                  name="userName"
                  placeholder="username"
                  value={signUpData.userName}
                  onChange={(e) =>
                    setSignUpData({ ...signUpData, userName: e.target.value })
                  }
                />
              </div>
              <div>
                <i className="fa-solid fa-lock"></i>
                <input
                  type="password"
                  name="password"
                  placeholder="password"
                  value={signUpData.password}
                  onChange={(e) =>
                    setSignUpData({ ...signUpData, password: e.target.value })
                  }
                />
              </div>
              <button type="submit" className="btn">
                Sign up
              </button>
            </form>
            <div className="login">
              <div>
                <span></span>
                <h4> Already created an account?</h4>
                <span></span>
              </div>
              <Link to="/login">
                {" "}
                <button className="btn"> Sign In</button>
              </Link>
            </div>
          </>
        )}
      </Wrapper>
    </>
  );
};

const Wrapper = styled.section`
  width: 90%;
  max-width: 400px;
  min-height: 55vh;
  background-color: var(--color-primary-3);
  margin: 10vh auto;
  padding: 2.5em;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 2em;
  * {
    color: var(--color-white);
  }
  > h1 {
    font-size: 2em;
    text-align: center;
  }
  > p {
    text-align: center;
    margin-bottom: 2em;
    margin-top: 0.5em;
  }
  > form {
    width: 100%;
    > div {
      width: 100%;
      padding: 10px 0;
      border-bottom: 1px solid var(--color-primary-2);
      margin: 10px 0;
      display: flex;
      align-items: center;

      > input {
        background: transparent;
        border: none;
        width: 100%;
        font-size: 1em;
        margin-left: 5px;
      }
      > input::placeholder {
        color: var(--color-primary-2);
      }
    }
    > button {
      width: 100%;
      font-size: 1em;
      font-weight: 700;
      margin-top: 20px;
    }
  }
  > .signup {
    width: 100%;
    margin: auto;
    margin-top: 2em;
    text-align: center;
    div {
      display: flex;
      align-items: center;
      > h4 {
        margin: 0 5px;
      }
      > span {
        flex: 1;
        height: 1px;
        background-color: var(--color-white);
      }
    }
    > a {
      > button {
        margin-top: 1em;
        width: 100%;
      }
    }
  }
  > .login {
    width: 100%;
    margin: auto;
    margin-top: 2em;
    text-align: center;
    div {
      display: flex;
      align-items: center;
      > h4 {
        margin: 0 5px;
      }
      > span {
        flex: 1;
        height: 1px;
        background-color: var(--color-white);
      }
    }
    > a {
      > button {
        margin-top: 1em;
        width: 100%;
      }
    }
  }
`;

export default SignUp;
